import React, { memo, useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { useLocation } from 'react-router-dom'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import Popover from '@material-ui/core/Popover'
import ChevronRightIcon from '@material-ui/icons/ChevronRight'
import SingleItem from './SingleItem'
import {
  StyledSubList,
  StyledListItem,
  StyledListItemText
} from './styles'

function ExpandbleItem ({
  icon,
  title,
  selected,
  subItems,
  menuOpened,
  isSubitem,
  path,
  closeMenu,
  menuItem
}) {
  const [anchorEl, setAnchorEl] = useState(null)
  const location = useLocation()

  const handleClick = (event) => {
    if (!isSubitem) {
      window.dispatchEvent(new window.CustomEvent('gpc-force-active-menu-item', { detail: { menuItem } }))
    }
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
    if (!isSubitem) {
      window.dispatchEvent(new window.CustomEvent('gpc-force-active-menu-item', { detail: { menuItem: null } }))
    }
  }

  useEffect(() => {
    if (!menuOpened) {
      handleClose()
    }
  }, [menuOpened])

  const open = Boolean(anchorEl)
  const isActuallySelected = selected || location.pathname === path

  return (
    <div>
      <StyledListItem
        button
        dataTestId={title}
        selected={isActuallySelected || open}
        isSubitem={isSubitem}
        onClick={handleClick}
      >
        {icon && <ListItemIcon>
          {icon}
        </ListItemIcon>}
        <StyledListItemText primary={title} rootLevel />
        <ChevronRightIcon
          style={{
            transition: 'transform 0.3s',
            transform: open ? 'rotate(180deg)' : 'rotate(0deg)',
            color: (isActuallySelected || open) ? '#2036C7' : 'inherit'
          }}
        />
      </StyledListItem>
      <Popover
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        disablePortal={false}
        ModalProps={{
          disableAutoFocus: true,
          disableEnforceFocus: true,
          disableRestoreFocus: true
        }}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left'
        }}
        PaperProps={{
          className: 'gpc-sidepanel-popover-paper',
          'data-gpc-sidepanel': 'true',
          style: {
            marginLeft: '0px',
            borderRadius: '0px',
            boxShadow: '0px 2px 4px rgba(0,0,0,0.1)',
            borderLeft: '1px solid rgba(0, 0, 0, 0.12)',
            height: 'calc(100vh - 82px)',
            backgroundColor: '#E8EAF6'
          }
        }}
      >
        <StyledSubList
          component="div"
          disablePadding
          style={{
            backgroundColor: '#E8EAF6',
            height: '100%',
            overflowY: 'auto',
            width: '310px'
          }}
        >
          {subItems.map((subItem, index) => {
            const { subItems: nestedSubItems, closeMenu: itemCloseMenu } = subItem
            if (nestedSubItems && nestedSubItems.length > 0) {
              return (
                <ExpandbleItem
                  key={index}
                  {...subItem}
                  menuOpened={menuOpened}
                  isSubitem
                  closeMenu={closeMenu || itemCloseMenu}
                />
              )
            }
            return <SingleItem
              {...subItem}
              isSubitem
              key={index}
              closeMenu={() => {
                handleClose()
                if (itemCloseMenu) itemCloseMenu()
                else if (closeMenu) closeMenu()
              }}
            />
          })}
        </StyledSubList>
      </Popover>
    </div>
  )
}

ExpandbleItem.propTypes = {
  icon: PropTypes.element,
  selected: PropTypes.bool,
  title: PropTypes.string.isRequired,
  subItems: PropTypes.array.isRequired,
  menuOpened: PropTypes.bool.isRequired,
  isSubitem: PropTypes.bool,
  path: PropTypes.string,
  closeMenu: PropTypes.func,
  menuItem: PropTypes.string
}

ExpandbleItem.defaultProps = {
  icon: null,
  selected: false,
  isSubitem: false,
  path: '',
  closeMenu: () => {},
  menuItem: null
}

export default memo(ExpandbleItem)
